export default __webpack_public_path__ + "static/media/7.71427d55.png";